import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const moveToDataError = createApi('pricememo', 'POST');

const MoveToDataError = createSlice({
  name: 'MoveToDataError',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(moveToDataError.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(moveToDataError.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(moveToDataError.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default MoveToDataError.reducer;